import { create } from 'zustand';
import type { FeatureFlags } from '@/hooks/useFeatureFlags';

export interface FeatureFlagsState {
  featureFlags: FeatureFlags;
  featureFlagsReady: boolean;
  setFeatureFlags: (flags: FeatureFlags) => void;
  setFeatureFlagsReady: (ready: boolean) => void;
}

const useFeatureFlagsStore = create<FeatureFlagsState>((set) => ({
  featureFlags: { useNewDestinations: false, useGoogleApiForRBS: false, enablePopularFeaturedDestinations: false },
  featureFlagsReady: false,
  setFeatureFlags: (flags) => set({ featureFlags: flags }),
  setFeatureFlagsReady: (ready) => set({ featureFlagsReady: ready }),
}));

export default useFeatureFlagsStore;
